import {Stack, Typography} from "@mui/material";
import coaches from "../coaches/coaches";
import {Coach} from "../coaches/Coach";
import CoachComponent from "../coaches/CoachComponent";

const Rent = () => {
    return (
        <Stack direction="column" padding="40px 20px" gap="20px">
            <Typography variant="h5">
                Oferim spre închiriere următoarele autocare
            </Typography>
            {coaches.map((coach: Coach) =>
                <CoachComponent coach={coach}/>
            )}
        </Stack>
    )
}

export default Rent;